import { render } from "./DeleteResource.vue?vue&type=template&id=8cded57c&ts=true"
import script from "./DeleteResource.vue?vue&type=script&lang=ts"
export * from "./DeleteResource.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__